var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M206.104,424.432c2.384-4.592,4.328-9.231,5.776-13.8l1.352-4.288L232,401.729v-35.457l-18.776-4.615 l-1.352-4.288c-1.448-4.568-3.393-9.208-5.776-13.8l-2.072-3.992l10.04-16.584L189,297.92l-16.592,10.04l-3.984-2.071 c-4.568-2.369-9.216-4.313-13.816-5.776l-4.271-1.36L145.728,280h-35.456l-4.615,18.76l-4.272,1.36 c-4.576,1.456-9.224,3.399-13.824,5.776l-3.983,2.063l-16.584-10.04l-25.064,25.072l10.04,16.584l-2.072,3.992 c-2.384,4.592-4.328,9.231-5.775,13.8l-1.353,4.288L24,366.271v35.457l18.76,4.615l1.36,4.272 c1.456,4.584,3.399,9.231,5.783,13.815l2.072,3.992l-10.04,16.584l25.072,25.072l16.576-10.04l3.983,2.064 c4.593,2.384,9.248,4.327,13.824,5.775l4.272,1.36l4.607,18.76h35.456l4.616-18.76l4.272-1.36 c4.575-1.456,9.224-3.399,13.823-5.775l3.984-2.064l16.584,10.04l25.063-25.072l-10.039-16.584L206.104,424.432z M128,456 c-39.704,0-72-32.304-72-72c0-39.695,32.296-72,72-72s72,32.305,72,72C200,423.696,167.704,456,128,456z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M222.32,340.279c1.232,2.648,2.345,5.305,3.328,7.961L248,353.729v60.543l-22.353,5.496 c-0.983,2.656-2.096,5.313-3.328,7.96L229.752,440H488V328H229.752L222.32,340.279z M408,344h48v16h-16v64h-16v-64h-16V344z  M344,368c0-13.232,10.768-24,24-24c13.231,0,24,10.768,24,24v56h-16v-16h-16v16h-16V368z M280,344h24c13.231,0,24,10.768,24,24 c0,6.145-2.32,11.752-6.129,16c3.809,4.248,6.129,9.855,6.129,16c0,13.232-10.769,24-24,24h-24V344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M104,120h176v80H104V120z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M328,248h128v64H328V248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M312,400c0-4.408-3.585-8-8-8h-8v16h8C308.415,408,312,404.408,312,400z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M312,368c0-4.408-3.585-8-8-8h-8v16h8C308.415,376,312,372.408,312,368z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M376,368c0-4.408-3.585-8-8-8c-4.416,0-8,3.592-8,8v24h16V368z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1E6EC0",
    cx: 128,
    cy: 384,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M480,24H80c-4.416,0-8,3.592-8,8v40h416V32C488,27.592,484.415,24,480,24z M104,56H88V40h16V56z M136,56 h-16V40h16V56z M168,56h-16V40h16V56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M72,282.248l12.279,7.439c2.641-1.231,5.297-2.344,7.952-3.336L97.728,264h60.544l5.496,22.352 c2.664,0.984,5.32,2.097,7.96,3.336l19.721-11.943L225.704,312H312v-80h160v80h16V88H72V282.248z M440,216h-16v-16h16V216z  M472,216h-16v-16h16V216z M472,152h-16v-16h16V152z M312,104h160v16H312V104z M312,136h128v16H312V136z M312,168h160v16H312V168z  M312,200h96v16h-96V200z M232,280h-16v-16h16V280z M264,280h-16v-16h16V280z M296,280h-16v-16h16V280z M296,248H120v-16h176V248z  M88,104h208v112H88V104z M88,232h16v16H88V232z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EC0",
    d: "M128,328c-30.872,0-56,25.12-56,56s25.128,56,56,56s56-25.12,56-56S158.872,328,128,328z M128,424 c-22.057,0-40-17.943-40-40s17.943-40,40-40c22.056,0,40,17.943,40,40S150.056,424,128,424z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchIcon);
export default __webpack_public_path__ + "static/media/batch-icon.5941f47552a044da87b865f2c12e5484.svg";
export { ForwardRef as ReactComponent };